import styled from 'styled-components';
import dt from '../../shared/theme';

const Checkbox = styled.span`
  width: 18px;
  min-width: 18px;
  height: 18px;
  min-height: 18px;
  border: 1px solid #BBCBD8;
  border-radius: 2px;
  font-weight: ${props => dt(props).theme.fontWeightRegular};
  font-size: 11px;
  margin-left: auto;

  &.fa-check {
    color: white;
    background-color: ${props => dt(props).theme.bodyColor};
    border-color: ${props => dt(props).theme.bodyColor};
  }
`;
export default Checkbox;
